import { ChangeDetectorRef, Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
declare var $: any;

@Component({
  selector: 'app-access-details',
  templateUrl: './access-details.component.html',
  styleUrls: ['./access-details.component.css']
})
export class AccessDetailsComponent {
  submitted = false;
  checked: any;
  verify: any;
  userAccessForm: FormGroup;
  accessMapping: FormArray;
  userMenusImpls: FormArray;
  userMenusImpls2: FormArray;
  user: any = {};
  action: string;
  initialValue: string;
  config: any = config;
  menuList: any = [];
  message: string;
  userDetails: any;
  access: any;
  manageAccess: any = [];
  manageAccessData: any;
  menuCode: string = 'useraccess';
  disableManage: boolean = true;
  userControlId: string = '';
  disableField: boolean = false;
  menuListFinal: any = [];

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private appService: AppService,
    private toastr: ToastrService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private cdref: ChangeDetectorRef) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.user = this.userDetailsService.getUserById(params['id']);
      }
    });
  }

  get f() { return this.userAccessForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle('Access Management');
    this.userAccessForm = this.formBuilder.group({
      checked: false,
      verify: false,
      accessMapping: this.formBuilder.array([]),
    });
    this.getDataForUser(this.user.userId || 0);
    this.userDetails = this.userDetailsService.getUserDetails();
    // this.menuListFinal = this.userDetails.menusList;
    // this.setFormData();
  }

  ngAfterViewInit(): void {
    $('.selectpicker').selectpicker();
  }

  getDataForUser(userId: number) {
    this.spinner.show();
    this.appService.getUserDetails(userId).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        this.spinner.hide();
        this.menuListFinal = response.data[0].menusList;
        this.setFormData();
      }
    );
  }

  setFormData() {
    let accessMappingControl = <FormArray>this.f.accessMapping;
    this.menuListFinal.forEach((element, index) => {
      accessMappingControl.push(this.formBuilder.group({
        checked: false,
        verify: false,
        userMenuMapId: [element.userMenuMapId],
        userId: [element.userId],
        menuId: [element.menuId],
        menuName: [element.menuName],
        menuCode: [element.menuCode],
        isAccessAllowed: [element.isAccessAllowed],
        isActive: [element.isActive],
        isDeleted: [element.isDeleted],
        checkedStatus: [element.checkedBy ? 'approve' : null],
        checkedBy: [element.checkedBy || null],
        checkedDate: [element.checkedDate || null],
        createdBy: [element.createdBy],
        createdDate: [element.createdDate],
        lastModifiedBy: [element.lastModifiedBy],
        lastModifiedDate: [element.lastModifiedDate],
        userMenusImpls: this.formBuilder.array([])
      }));

      if (element.userMenusImpls) {
        element.userMenusImpls.forEach(element1 => {
          (accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray).push(this.formBuilder.group({
            checked: false,
            verify: false,
            userMenuMapId: [element1.userMenuMapId],
            userId: [element1.userId],
            menuId: [element1.menuId],
            menuName: [element1.menuName],
            menuCode: [element1.menuCode],
            isAccessAllowed: [element1.isAccessAllowed],
            isActive: [element1.isActive],
            isDeleted: [element1.isDeleted],
            checkedStatus: [element1.checkedBy ? 'approve' : null],
            checkedBy: [element1.checkedBy || null],
            checkedDate: [element1.checkedDate || null],
            createdBy: [element1.createdBy],
            createdDate: [element1.createdDate],
            lastModifiedBy: [element1.lastModifiedBy],
            lastModifiedDate: [element1.lastModifiedDate],
            userMenusImpls2: this.formBuilder.array([])
          }))

          // let menuMappingControl = <FormArray>(accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray);
          // if (element1.userMenusImpls) {
          //   element1.userMenusImpls.forEach(element2 => {
          //     (menuMappingControl.at(menuMappingControl.length - 1).get('userMenusImpls2') as FormArray).push(this.formBuilder.group({
          //       checked: false,
          //       verify: false,
          //       userMenuMapId: [element2.userMenuMapId],
          //       userId: [element2.userId],
          //       menuId: [element2.menuId],
          //       menuName: [element2.menuName],
          //       menuCode: [element2.menuCode],
          //       isAccessAllowed:[element2.isAccessAllowed],
          //       isActive: [element2.isActive],
          //       isDeleted: [element2.isDeleted],
          //       checkedStatus: [element2.checkedBy ? 'approve' : null],
          //       checkedBy: [element2.checkedBy || null],
          //       checkedDate: [element2.checkedDate || null],
          //       createdBy: [element2.createdBy],
          //       createdDate: [element2.createdDate],
          //       lastModifiedBy: [element2.lastModifiedBy],
          //       lastModifiedDate: [element2.lastModifiedDate],
          //     }))
          //   });
          // }
        });
      }
    });
    this.accessMapping = <FormArray>this.f.accessMapping;
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  onSubmit() {
    let requestObject = { "userMenuMappings": [] };
    this.userAccessForm.getRawValue().accessMapping.forEach((element, index) => {
      requestObject.userMenuMappings.push(
        {
          "userMenuMapId": element.userMenuMapId,
          "userId": element.userId,
          "menuId": element.menuId,
          "menuName": element.menuName,
          "menuCode": element.menuCode,
          "roleId": 1,
          "isAccessAllowed": element.isAccessAllowed,
          "accessType": (element.isAccessAllowed == 'Y') ? 'W' : 'R',
          "isActive": (element.isAccessAllowed == 'N') ? 'N' : element.isActive,
          "isDeleted": element.isDeleted,
          "checkedBy": element.checkedBy,
          "checkedDate": new Date(element.checkedDate),
          "createdBy": element.createdBy,
          "createdDate": new Date(element.createdDate),
          "lastModifiedBy": element.lastModifiedBy,
          "lastModifiedDate": new Date(element.lastModifiedDate)
        });

      if (element.userMenusImpls) {
        element.userMenusImpls.forEach(element1 => {
          requestObject.userMenuMappings.push(
            {
              "userMenuMapId": element1.userMenuMapId,
              "userId": element1.userId,
              "menuId": element1.menuId,
              "menuName": element1.menuName,
              "menuCode": element1.menuCode,
              "roleId": 1,
              "isAccessAllowed": element1.isAccessAllowed,
              "accessType": (element1.isAccessAllowed == 'Y') ? 'W' : 'R',
              "isActive": (element1.isAccessAllowed == 'N') ? 'N' : element1.isActive,
              "isDeleted": element1.isDeleted,
              "checkedBy": element1.checkedBy,
              "checkedDate": new Date(element1.checkedDate),
              "createdBy": element1.createdBy,
              "createdDate": new Date(element1.createdDate),
              "lastModifiedBy": element1.lastModifiedBy,
              "lastModifiedDate": new Date(element1.lastModifiedDate)
            })
          // if (element1.userMenusImpls2) {
          //   element1.userMenusImpls2.forEach(element2 => {
          //     requestObject.userMenuMappings.push(
          //       {
          //         "userMenuMapId": element2.userMenuMapId,
          //         "userId": element2.userId,
          //         "menuId": element2.menuId,
          //         "menuName": element2.menuName,
          //         "menuCode": element2.menuCode,
          //         "isAccessAllowed": element2.isAccessAllowed,
          //         "isActive": element2.isActive,
          //         "isDeleted": element2.isDeleted,
          //         "checkedBy": element2.checkedBy,
          //         "checkedDate": new Date(element2.checkedDate),
          //         "createdBy": element2.createdBy,
          //         "createdDate": new Date(element2.createdDate),
          //         "lastModifiedBy": element2.lastModifiedBy,
          //         "lastModifiedDate": new Date(element2.lastModifiedDate)
          //       })
          //   });
          // }
        });
      }
    });

    this.appService.saveUserMenuMappings(requestObject).pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.cdref.detectChanges();
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe(
      (response: any) => {
        if (response.statusCode == 200) {
          if (this.route.parent.snapshot.routeConfig.path == 'userList') {
            if (this.userDetails.entityType == 'ADMIN')
              this.toastr.success('Menu access submitted');
            else
              this.toastr.success('Menu access requested');
            this.router.navigate(['../'], { skipLocationChange: true, relativeTo: this.route });
          } else {
            this.toastr.success('Menu access requested');
            this.router.navigate(['/settings']);
          }
        } else {
          this.message = response.message;
          this.toastr.error(this.message);
        }
      }
    )
  }

  cancelForm() {
    if (this.route.parent.snapshot.routeConfig.path == 'userList') {
      this.router.navigate(['../'], { skipLocationChange: true, relativeTo: this.route });
    } else {
      this.router.navigate(['/settings']);
    }
  }

  checkRecordMenu(menuAccess, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].lastModifiedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('Y');
    } else {
      menuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].lastModifiedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('N');
    }
    if (menuAccess['controls'].userMenusImpls.length > 0) {
      menuAccess['controls'].userMenusImpls['controls'].forEach(element => {
        if (checkStatus == 'approve') {
          element['controls'].lastModifiedBy.setValue(this.userDetails.userId);
          element['controls'].lastModifiedDate.setValue(new Date());
          element['controls'].isAccessAllowed.setValue('Y');
        } else {
          element['controls'].lastModifiedBy.setValue(this.userDetails.userId);
          element['controls'].lastModifiedDate.setValue(new Date());
          element['controls'].isAccessAllowed.setValue('N');
        }
        if (element['controls'].userMenusImpls2.length > 0) {
          element['controls'].userMenusImpls2['controls'].forEach(element1 => {
            if (checkStatus == 'approve') {
              element1['controls'].lastModifiedBy.setValue(this.userDetails.userId);
              element1['controls'].lastModifiedDate.setValue(new Date());
              element1['controls'].isAccessAllowed.setValue('Y');
            } else {
              element1['controls'].lastModifiedBy.setValue(this.userDetails.userId);
              element1['controls'].lastModifiedDate.setValue(new Date());
              element1['controls'].isAccessAllowed.setValue('N');
            }
          });
        }
      });
    }
  }

  checkRecordMenuAdmin(menuAccess, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].checkedDate.setValue(new Date());
      menuAccess['controls'].isActive.setValue('Y');
    } else {
      menuAccess['controls'].checkedBy.setValue(null);
      menuAccess['controls'].checkedDate.setValue(null);
      menuAccess['controls'].isActive.setValue('N');
    }
    if (menuAccess['controls'].userMenusImpls.length > 0) {
      menuAccess['controls'].userMenusImpls['controls'].forEach(element => {
        if (checkStatus == 'approve') {
          element['controls'].checkedBy.setValue(this.userDetails.userId);
          element['controls'].checkedDate.setValue(new Date());
          element['controls'].isActive.setValue('Y');
        } else {
          element['controls'].checkedBy.setValue(null);
          element['controls'].checkedDate.setValue(null);
          element['controls'].isActive.setValue('N');
        }
        if (element['controls'].userMenusImpls2.length > 0) {
          element['controls'].userMenusImpls2['controls'].forEach(element1 => {
            if (checkStatus == 'approve') {
              element1['controls'].checkedBy.setValue(this.userDetails.userId);
              element1['controls'].checkedDate.setValue(new Date());
              element1['controls'].isActive.setValue('Y');
            } else {
              element1['controls'].checkedBy.setValue(null);
              element1['controls'].checkedDate.setValue(null);
              element1['controls'].isActive.setValue('N');
            }
          });
        }
      });
    }
  }

  checkRecordSubMenu(menuAccess, subMenuAccess, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].lastModifiedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('Y');
      subMenuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      subMenuAccess['controls'].lastModifiedDate.setValue(new Date());
      subMenuAccess['controls'].isAccessAllowed.setValue('Y');
    } else {
      subMenuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      subMenuAccess['controls'].lastModifiedDate.setValue(new Date());
      subMenuAccess['controls'].isAccessAllowed.setValue('N');
    }
    if (subMenuAccess['controls'].userMenusImpls2.length > 0) {
      subMenuAccess['controls'].userMenusImpls2['controls'].forEach(element => {
        if (checkStatus == 'approve') {
          element['controls'].lastModifiedBy.setValue(this.userDetails.userId);
          element['controls'].lastModifiedDate.setValue(new Date());
          element['controls'].isAccessAllowed.setValue('Y');
        } else {
          element['controls'].lastModifiedBy.setValue(this.userDetails.userId);
          element['controls'].lastModifiedDate.setValue(new Date());
          element['controls'].isAccessAllowed.setValue('N');
        }
      });
    }
  }

  checkRecordSubMenuAdmin(menuAccess, subMenuAccess, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].checkedDate.setValue(new Date());
      menuAccess['controls'].isActive.setValue('Y');
      subMenuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
      subMenuAccess['controls'].checkedDate.setValue(new Date());
      subMenuAccess['controls'].isActive.setValue('Y');
    } else {
      subMenuAccess['controls'].checkedBy.setValue(null);
      subMenuAccess['controls'].checkedDate.setValue(null);
      subMenuAccess['controls'].isActive.setValue('N');
    }
    if (subMenuAccess['controls'].userMenusImpls2.length > 0) {
      subMenuAccess['controls'].userMenusImpls2['controls'].forEach(element => {
        if (checkStatus == 'approve') {
          element['controls'].checkedBy.setValue(this.userDetails.userId);
          element['controls'].checkedDate.setValue(new Date());
          element['controls'].isActive.setValue('Y');
        } else {
          element['controls'].checkedBy.setValue(null);
          element['controls'].checkedDate.setValue(null);
          element['controls'].isActive.setValue('N');
        }
      });
    }
  }

  checkRecordSubMenu2(menuAccess, subMenuAccess, subMenuAccess2, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].lastModifiedDate.setValue(new Date());
      menuAccess['controls'].isAccessAllowed.setValue('Y');
      subMenuAccess['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      subMenuAccess['controls'].lastModifiedDate.setValue(new Date());
      subMenuAccess['controls'].isAccessAllowed.setValue('Y');
      subMenuAccess2['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      subMenuAccess2['controls'].lastModifiedDate.setValue(new Date());
      subMenuAccess2['controls'].isAccessAllowed.setValue('Y');
    } else {
      subMenuAccess2['controls'].lastModifiedBy.setValue(this.userDetails.userId);
      subMenuAccess2['controls'].lastModifiedDate.setValue(new Date());
      subMenuAccess2['controls'].isAccessAllowed.setValue('N');
    }

  }

  checkRecordSubMenu2Admin(menuAccess, subMenuAccess, subMenuAccess2, checkStatus) {
    if (checkStatus == 'approve') {
      menuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
      menuAccess['controls'].checkedDate.setValue(new Date());
      menuAccess['controls'].isActive.setValue('Y');
      subMenuAccess['controls'].checkedBy.setValue(this.userDetails.userId);
      subMenuAccess['controls'].checkedDate.setValue(new Date());
      subMenuAccess['controls'].isActive.setValue('Y');
      subMenuAccess2['controls'].checkedBy.setValue(this.userDetails.userId);
      subMenuAccess2['controls'].checkedDate.setValue(new Date());
      subMenuAccess2['controls'].isActive.setValue('Y');
    } else {
      subMenuAccess2['controls'].checkedBy.setValue(null);
      subMenuAccess2['controls'].checkedDate.setValue(null);
      subMenuAccess2['controls'].isActive.setValue('N');
    }

  }

  onVerifyAll() {
    if (this.f.verify.value) {
      this.f.accessMapping['controls'].forEach(menuAccess => {
        this.checkRecordMenu(menuAccess, "approve");
      });
    } else {
      this.f.accessMapping['controls'].forEach(menuAccess => {
        this.checkRecordMenu(menuAccess, "reject");
      });
    }
  }

}
